import {NgModule, Injectable} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccentService, CoreModule, WebSocketClientService} from "inet-core";
import {ChatMessageService} from "./message.service";
import {ContactListComponent} from "./component/contact-list/contact-list.component";
import {MessageChatComponent} from "./component/message-chat/message-chat.component";
import {SearchInputComponent} from './component/search-input/search-input.component';
import {MessagePanelComponent} from './component/message-panel/message-panel.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AutosizeModule} from "ngx-autosize";
import {FileListModule} from "./filelist/file-list.module";
import {RoomChatComponent} from "./component/room-chat/room-chat.component";
import {VideoConferenceService} from "./video-conference.service";
import {OpenGraphModule} from './open-graph/open-graph.module';
import {MessageGroupComponent} from "./component/message-group/message-group.component";
import {ModalModule} from "ngx-bootstrap/modal";
import {DialogModule, SafePipeModule} from "inet-ui";
import {GroupCallListComponent} from "./component/group-call-list/group-call-list.component";
import {VideoChatSubscribeComponent} from './video-chat-subscribe/video-chat-subscribe.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    AutosizeModule,
    FileListModule,
    OpenGraphModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    DialogModule,
    SafePipeModule
  ],
  exports: [
    MessageChatComponent,
    ContactListComponent,
    SearchInputComponent,
    MessagePanelComponent,
    MessageGroupComponent,
    GroupCallListComponent,
    VideoChatSubscribeComponent
  ],
  declarations: [
    MessageChatComponent,
    ContactListComponent,
    SearchInputComponent,
    MessagePanelComponent,
    RoomChatComponent,
    MessageGroupComponent,
    GroupCallListComponent,
    VideoChatSubscribeComponent
  ],
  providers: [
    AccentService,
    ChatMessageService,
    VideoConferenceService,
    WebSocketClientService
  ]
})
export class ChatMessageModule {
  constructor() {

  }
}
